<template>
  <div
    :style="{ 'left': `${leftPos}px` }"
    class="foreground">
    <img
      class="image"
      src="../assets/img/Voorgrond.svg">
    <img
      class="image"
      src="../assets/img/Voorgrond.svg">
    <img
      class="image"
      src="../assets/img/Voorgrond.svg">
    <img
      class="image"
      src="../assets/img/Voorgrond.svg">
    <img
      class="image"
      src="../assets/img/Voorgrond.svg">
    <img
      class="image"
      src="../assets/img/Voorgrond.svg">
    <img
      class="image"
      src="../assets/img/Voorgrond.svg">
  </div>
</template>
<script>
export default {
  props: {
    scrollPosition: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      scrollSpeed: 3,
      leftPos: 0,
    };
  },
  watch: {
    scrollPosition() {
      this.leftPos = (this.scrollPosition * this.scrollSpeed) * -1;
    },
  },
};
</script>
<style lang="scss" scoped>
  .foreground {
    display: flex;
    flex-flow: row nowrap;
    height: 50%;
    width: auto;
    position: absolute;
    bottom: -50px;
    left: 0;
    text-align: left;
  }

  .image {
    height: 100%;
    width: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/ForeGround.vue